<div class="empty-msg">
  <figure>
    <img src="/assets/images/CETV-logo.png">
  </figure>
  <p>{{message}}</p>
  <a *ngIf="linkMessage" [routerLink]="link">
    {{linkMessage}}
  </a>
</div>
